export default (graphComponentRef, documentObject, layout) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph))
        return undefined;
    const node = layout
        ? graphComponentRef.current.graph.createNode({ tag: documentObject, layout })
        : graphComponentRef.current.graph.createNode({ tag: documentObject });
    return node;
};
